<script>
import LogicFlow from '@qiov/logicflow-core'
import '@logicflow/extension/lib/style/index.css'
import '@qiov/logicflow-core/dist/style/index.css'
import NodeRedExtension from '@/components/NodeRed/lockIndex'
// import Setting from '@/components/NodeRed/tools/Setting.vue'
import eventBus from '@/utils/eventBus'

import '@/components/NodeRed/style.css'
export default {
  name: 'FlowChart',
  data() {
    return {
      count: 0,
      currentNode: null
    }
  },
  mounted() {
    this.lf = new LogicFlow({
      container: this.$refs.container,
      grid: {
        visible: true,
        type: 'mesh',
        size: 10,
        config: {
          color: '#eeeeee'
        }
      },
      adjustEdge: true,
      hoverOutline: false,
      edgeSelectedOutline: false,
      isSilentMode: true,
      keyboard: {
        enabled: false
      },
      plugins: [
        NodeRedExtension
      ]
    })
    eventBus.$on('loadNode', (param) => {
      // console.log(JSON.parse(param), 666)
      this.lf.render(JSON.parse(param))
      eventBus.$emit('loadNodeReturn', this.lf)
    })
    this.lf.on('node-red:start', () => {
      // todo: 让流程跑起来
      console.log('我要开始执行流程了')
    })
    this.lf.on('vue-node:click', (data) => {
      this.lf.setProperties(data.id, {
        t: ++data.val
      })
    })
    this.lf.on('node:click', ({ data }) => {
      this.currentNode = data
      this.$emit('sendAttr', this.currentNode)
      console.log('node click', this.currentNode)
    })
    this.lf.on('blank:click', ({ data }) => {
      this.currentNode = null
      this.$emit('clearNode')
    })
    this.lf.on('node:delete', ({ data }) => {
      if (data.type === 'start-node') {
        this.$message.warning('请不要删除关键节点')
        this.lf.addNode(data)
        return
      }
      this.currentNode = null
      this.$emit('clearNode')
    })
  },
  methods: {
    changeStyle(style) {
      this.lf.setProperties(this.currentNode.id, {
        style
      })
    },
    getNewServe(serve) {
      this.currentNode = serve
      this.lf.updateText(serve.id, this.currentNode.text.value)
      this.lf.setProperties(this.currentNode.id, this.currentNode.properties)
    }
  }
}
</script>

<template>
  <div class="flow-chart">
    <div ref="container" class="container"></div>
    <!-- <Setting v-if="currentNode" @changeStyle="changeStyle" :nodeData="currentNode" class="setting-panel"></Setting> -->
  </div>
</template>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.flow-chart {
  position: relative;
  width: calc(100% - 420px);
  height: 100%;
}
.flow-chart /deep/ .lf-red-node, .flow-chart /deep/ .lf-element-text {
  cursor: move;
}
.flow-chart /deep/ svg {
  display: block;
}
.flow-chart-palette {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.setting-panel {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
